import React, { useMemo } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useThemeStore } from '../shared/theme';
import type { MainStackParamList } from './types';
import { renderRegistryStackScreens } from './stackScreenFactory';
import { getMainStackInitialRoute } from '../exDev/environment/devInitialScreens';
import { createStackScreenOptions } from '../shared/navigation/stackScreenOptions';

const Stack = createNativeStackNavigator<MainStackParamList>();

/** Authenticated stack — screens from `shared/navigation/screenRegistry`. */
export function MainStackNavigator() {
  const appearance = useThemeStore(state => state.appearance);

  const ios_status_bar_style = useMemo(
    () => (appearance === 'dark' ? 'light' : 'dark') as 'light' | 'dark',
    [appearance],
  );

  return (
    <Stack.Navigator
      initialRouteName={getMainStackInitialRoute()}
      screenOptions={createStackScreenOptions(ios_status_bar_style)}>
      {renderRegistryStackScreens(Stack, 'main')}
    </Stack.Navigator>
  );
}
